import { getLogIndex, setLogIndex } from '../../util/localstorage';
import * as ACTIONS from '../actions/eth';

const INITIAL_STATE = {
    accounts: [],
    lastLogIndex: getLogIndex(),
    offers: {
        sell: [],
        buy: []
    },
    newOffers: {
        buy: 0,
        sell: 0
    },
    network: 0x1
}

const reducer = ( state=INITIAL_STATE, action ) => {

    const offers = { ...state.offers };
    let newOffers = { ...state.newOffers };

    switch( action.type ){

        case ACTIONS.BLOCK_HISTORY_OFFERS:

            const allOffers = [ ...offers.sell, ...offers.buy ];

            let lastLogIndex = state.lastLogIndex;
            
            allOffers.forEach( ({ logIndex }) => {
                if( logIndex > lastLogIndex ) lastLogIndex = logIndex;
            });

            setLogIndex( lastLogIndex );
            
            return { ...state, lastLogIndex, newOffers: { ...INITIAL_STATE.newOffers } };

        case ACTIONS.SET_ACCOUNTS:
            return { ...state, accounts: action.payload, offers: { ...INITIAL_STATE.offers } };
        case ACTIONS.SET_NETWORK:
            return { ...state, network: action.payload };
        case ACTIONS.SET_OFFER_HISTORY:

            if( action.payload.address !== state.accounts[ 0 ] ){
                return { ...state };

            } else {

                for( let direction in action.payload ){
                    const history = action.payload[ direction ];

                    // offers
                    for( let index in history.offers ){
                        const offer = history.offers[ index ],
                        exists = offerExists( offers[ direction ], offer );
                        if( !exists ) offers[ direction ].unshift({ ...offer.returnValues, logIndex: offer.logIndex, blockNumber: offer.blockNumber });
                    }

                    // approvals
                    for( let index in history.approvals ){
                        const approval = history.approvals[ index ],
                        [ approvedOffer, aOIndex ] = findOffer( offers[ direction ], approval.returnValues );
                        if( approvedOffer && approvedOffer.logIndex !== approval.logIndex ){
                            approvedOffer.approved = true;
                            approvedOffer.blockNumber = approval.blockNumber;
                            approvedOffer.logIndex = approval.logIndex;
                            offers[ direction ][ aOIndex ] = approvedOffer;
                        }
                    }

                    // rejections
                    for( let index in history.rejections ){
                        const rejection = history.rejections[ index ],
                        [ rejectedOffer, rOIndex ] = findOffer( offers[ direction ], rejection.returnValues );
                        if( rejectedOffer && rejectedOffer.logIndex !== rejection.logIndex ){
                            rejectedOffer.approved = false;
                            rejectedOffer.blockNumber = rejection.blockNumber;
                            rejectedOffer.logIndex = rejection.logIndex;
                            offers[ direction ][ rOIndex ] = rejectedOffer;
                        }
                    }

                    // purchases
                    for( let index in history.purchases ){
                        const purchase = history.purchases[ index ],
                        [ purchasedOffer, pOIndex ] = findOffer( offers[ direction ], purchase.returnValues );
                        if( purchasedOffer && purchasedOffer.logIndex !== purchase.logIndex ){
                            purchasedOffer.purchased = true;
                            purchasedOffer.blockNumber = purchase.blockNumber;
                            purchasedOffer.logIndex = purchase.logIndex;
                            offers[ direction ][ pOIndex ] = purchasedOffer;
                        }
                    }

                    // last loop
                    for( let index in offers[ direction ] ){
                        const { logIndex } = offers[ direction ][ index ];
                        newOffers = updateNewOfferCount( newOffers, direction, state.lastLogIndex, logIndex );
                    }
                    
                }
            }

            return { ...state, offers, newOffers };
        
        case ACTIONS.SET_OFFERS:
            if( action.payload.address !== state.accounts[ 0 ] ){
                return { ...state };
            } else {
                const exists = offerExists( offers[ action.payload.direction ], action.payload.offer );
                if( !exists ){
                    offers[ action.payload.direction ].unshift({ ...action.payload.offer.returnValues, logIndex: action.payload.offer.logIndex, blockNumber: action.payload.offer.blockNumber });
                    newOffers = updateNewOfferCount( newOffers, action.payload.direction, state.lastLogIndex, action.payload.offer.logIndex );
                } 
                return { ...state, offers, newOffers };
            }
        case ACTIONS.SET_PURCHASES:
            const [ finalOffer, finalIndex ] = findOffer( offers[ action.payload.direction ], action.payload.offer.returnValues );
            if( finalOffer && !finalOffer.hasOwnProperty( 'purchased' ) ){
                finalOffer.purchased = true;
                finalOffer.blockNumber = action.payload.offer.blockNumber;
                finalOffer.logIndex = action.payload.offer.logIndex;
                offers[ action.payload.direction ][ finalIndex ] = finalOffer;
                newOffers = updateNewOfferCount( newOffers, action.payload.direction, state.lastLogIndex, action.payload.offer.logIndex );
            }
            return { ...state, offers, newOffers };
        case ACTIONS.SET_RESPONSES:
            const [ offer, index ] = findOffer( offers[ action.payload.direction ], action.payload.offer.returnValues );
            if( offer && !offer.hasOwnProperty( 'approved' ) ){
                offer.approved = action.payload.approved;
                offer.blockNumber = action.payload.offer.blockNumber;
                offer.logIndex = action.payload.offer.logIndex;
                offers[ action.payload.direction ][ index ] = offer;
                newOffers = updateNewOfferCount( newOffers, action.payload.direction, state.lastLogIndex, action.payload.offer.logIndex );
            }
            return { ...state, offers, newOffers }
            
        default:
            return { ...state };
    }

}

function updateNewOfferCount( counts, direction, lastIndex, checkIndex ){
    if( checkIndex > lastIndex ){
        ++counts[ direction ];
    }
    return counts;
}

function offerExists( offers, offer ){
    const { logIndex } = offer,
    { buyer, seller, amount, token } = offer.returnValues,
    exists = offers.some( offer => {
        if( offer.logIndex === logIndex ){
            return true;
        } else {
            return (
                offer.buyer === buyer &&
                offer.seller === seller &&
                offer.amount === amount &&
                offer.token === token
            );
        }
    });
    return exists
}

function findOffer( offers, offer ){
    const { buyer, seller, tokenId, amount } = offer,
    index = offers.findIndex( offer => {
        const sellerMatch = seller.toLowerCase() === offer.seller.toLowerCase(),
        buyerMatch = buyer.toLowerCase() === offer.buyer.toLowerCase(),
        tokenMatch = tokenId === offer.tokenId,
        amountMatch = amount === offer.amount;
        return ( sellerMatch && buyerMatch && tokenMatch && amountMatch );
    });
    return [ offers[ index ], index ];
}

export default reducer;